import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetFileTasks } from './Document.hook';
import { WorkflowEntity } from '../workflow/Workflow.interface';
import { Task } from '../tasks/Task.interface';
import TaskBoard from '../tasks/TaskBoard';
import { ApiParams } from '../../common/api/api';
import AppSnackbar from '../../common/AppSnackbar';

export interface DocumentTaskBoardProps {
  apiParams: ApiParams;
  disabled?: boolean;
}

const DocumentTaskBoard: React.FC<DocumentTaskBoardProps> = (
  props: DocumentTaskBoardProps
) => {
  const { apiParams, disabled } = props;
  const history = useHistory();
  const [tasks, setTasks] = useState<Task[]>([]);
  const [{ data: foundTasks, error }, getTasks] = useGetFileTasks();

  useEffect(() => {
    getTasks(apiParams);
  }, [getTasks, apiParams]);

  useEffect(() => {
    foundTasks && setTasks(foundTasks);
  }, [foundTasks]);

  return (
    <>
      <TaskBoard
        disabled={disabled}
        apiParams={apiParams}
        entity={WorkflowEntity.File}
        tasks={tasks}
        onSelectTask={task => {
          const taskId = task.parent?.id || task.id;
          history.push(`/portal/documents/file/task/${taskId}`);
        }}
      />
      <AppSnackbar severity='error' open={Boolean(error)}>
        {error?.message}
      </AppSnackbar>
    </>
  );
};

export default DocumentTaskBoard;
